import React, { useEffect, useState } from 'react';
import PersonSelect from '../PersonSelect';
import useApiStable from "../../utils/useApiStable";
import '../../styles/TaskList.css';



function TaskForm({ task, onClose }) {
  const [title, setTitle] = useState(task?.title || '');
  const [description, setDescription] = useState(task?.description || '');
  const [startDate, setStartDate] = useState(task?.startDate || '');
  const [duration, setDuration] = useState(task?.duration || 60);
  const [responsible, setResponsible] = useState(task?.responsible?.id || '');
  const [assignedPersons, setAssignedPersons] = useState(task?.assignedPersons?.map(p => p.id) || []);
  const [persons, setPersons] = useState([]);
  const [loadingPersons, setLoadingPersons] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false); // neu: Löschstatus
  const [error, setError] = useState('');
  const [validationError, setValidationError] = useState('');

  const api = useApiStable();

  useEffect(() => {
    setLoadingPersons(true);
    api.get('/persons')
      .then(data => setPersons(Array.isArray(data) ? data : []))
      .catch(err => setError(err.message || 'Fehler beim Laden der Personen'))
      .finally(() => setLoadingPersons(false));
  }, []);

  const validate = () => {
    if (!startDate) {
      setValidationError('Startzeit ist erforderlich.');
      return false;
    }
    setValidationError('');
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (!validate()) return;
    console.log("Assigned Persons:" + assignedPersons)

    const payload = {
      title,
      description,
      startDate,
      duration,
      responsibleId: responsible ? Number(responsible) : null,
      assignedPersons: assignedPersons
    };
    console.debug('Task submit payload', payload);
    setSaving(true);
    const request = task
      ? api.put(`/tasks/${task.id}`, payload)
      : api.post('/tasks', payload);
    request
      .then(() => onClose(true))
      .catch(err => setError(err.message || 'Fehler beim Speichern der Aufgabe'))
      .finally(() => setSaving(false));
  };

  const handleDelete = () => {
    if (!task || !task.id) return;
    if (!window.confirm('Diese Aufgabe wirklich löschen?')) return;
    setError('');
    setDeleting(true);
    api.delete(`/tasks/${task.id}`)
      .then(() => onClose(true))
      .catch(err => setError(err.message || 'Fehler beim Löschen der Aufgabe'))
      .finally(() => setDeleting(false));
  };

  return (
    <div className="taskform-card">
      <h3 style={{marginBottom:'18px'}}>{task ? 'Aufgabe bearbeiten' : 'Neue Aufgabe erstellen'}</h3>
      {error && <div className="taskform-error">{error}</div>}
      {validationError && <div className="taskform-error">{validationError}</div>}
      <form onSubmit={handleSubmit} className={saving ? 'taskform-loading' : ''}>
        <div className="taskform-group">
          <label htmlFor="task-title">Titel *</label>
          <input id="task-title" value={title} onChange={e => setTitle(e.target.value)} placeholder="Titel" required disabled={saving} />
        </div>
        <div className="taskform-group">
          <label htmlFor="task-desc">Beschreibung</label>
            <textarea id="task-desc" value={description} onChange={e => setDescription(e.target.value)} placeholder="Beschreibung" disabled={saving} />
        </div>
        <div className="taskform-inline-row">
          <div className="taskform-group">
            <label htmlFor="task-start">Start *</label>
            <input id="task-start" type="datetime-local" value={startDate} onChange={e => setStartDate(e.target.value)} required disabled={saving} />
          </div>
        </div>
        <div className="taskform-inline-row">
          <div className="taskform-group">
            <label htmlFor="task-duration">Dauer *</label>
            <select id="task-duration" value={duration} onChange={e => setDuration(Number(e.target.value))} required
                    disabled={saving}>
              <option value={30}>0,5 Stunden</option>
              <option value={60}>1 Stunde</option>
              <option value={90}>1,5 Stunden</option>
              <option value={120}>2 Stunden</option>
              <option value={150}>2,5 Stunden</option>
              <option value={180}>3 Stunden</option>
              <option value={210}>3,5 Stunden</option>
              <option value={240}>4 Stunden</option>
              <option value={270}>4,5 Stunden</option>
              <option value={300}>5 Stunden</option>
              <option value={330}>5,5 Stunden</option>
              <option value={360}>6 Stunden</option>
              <option value={390}>6,5 Stunden</option>
              <option value={420}>7 Stunden</option>
              <option value={450}>7,5 Stunden</option>
              <option value={480}>8 Stunden</option>
            </select>
          </div>
          <div className="taskform-group">
            <PersonSelect persons={persons} value={responsible} label={"Verantwortlicher *"} onChange={setResponsible} single disabled={saving || loadingPersons} />
          </div>
        </div>
        <div className="taskform-group">
          <PersonSelect persons={persons} value={assignedPersons} label={'Zugewiesene Personen'} onChange={setAssignedPersons} disabled={saving || loadingPersons} />
        </div>
        <div className="taskform-actions" style={{marginTop:'6px'}}>
          {task && task.id && (
            <button type="button" className="taskform-delete-btn" onClick={handleDelete} disabled={saving || deleting} style={{marginRight: 'auto', background:'#dc3545', color:'#fff'}}>
              {deleting ? 'Lösche...' : 'Löschen'}
            </button>
          )}
          <button type="button" className="taskform-cancel-btn" onClick={() => onClose(false)} disabled={saving || deleting}>Abbrechen</button>
          <button type="submit" className="taskform-save-btn" disabled={saving || deleting || loadingPersons || !title}>Speichern {saving && <span className="taskform-spinner" style={{marginLeft:8, verticalAlign:'middle'}}/>}</button>
        </div>
      </form>
    </div>
  );
}

export default TaskForm;
